module.exports = __webpack_public_path__ + "img/11.06f1fd60.jpg";